const emptyDeviceSettings = {
    deviceIoSettingsId: 0,
    volumeCountIoId: 0,
    volumeRatio: 1,
    valveIoId: 0,
    userKeyIoId: 0,
    avtoKeyIoId: 0,
};

const emptyDevice = {
    deviceImei: "",
    name: "",
    description: "",
    protocolType: "",
    deviceTypeId: 1,
    isActive: false,
    deviceIoSettings: {},
    deviceExtendedIos: []
};

const emptyTank = {
    tankId: 0,
    tankName: "",
    minLevel: 0,
    maxLevel: 0,
    volume: 0,
    areaId: 0,
    department: "",
    fuelType: "",
    fuelNumber: "",
    graduationFileId: null,
    device: {}
}

export const getEmptyTank = () => {
    const tank = {...emptyTank, device: {...emptyDevice, deviceIoSettings: {...emptyDeviceSettings}}};    
    return tank;
}

export const api = {
    GET_TANKS_LIST_API : "/api/tanks/list",
    GET_TANKS_ALL_LIST_API: "/api/tanks/listAll",
    GET_TANK_API : "/api/tanks/getTank",
    EDIT_TANK_API : "/api/tanks/edit",
    ADD_TANK_API : "/api/tanks/add",
    GET_TANK_OPERATIONS_API : "/api/tanks/tankOperations",
    GET_TANKS_STATE_OPERATIONS_API : "/api/tanks/tanksStateOperations",
    GET_TANKS_STATE_OPERATIONS_REPORT_API : "/api/tanks/tanksStateOperationsReport",
    GET_TANK_OPERATIONS_REPORT_API : "/api/tanks/tankOperationReport",
    ADD_TANK_OPERATIONS_API : "/api/tanks/addOperation",
    GET_AREAS_API : "/api/tanks/areas",
    ADD_AREA_API : "/api/tanks/addArea",
    EDIT_AREA_API: "/api/tanks/updatearea",
    UPLOAD_GRADUATIONS: "/api/tanks/uploadGraduations",
    DOWNLOAD_GRADUATIONS: "/api/tanks/downloadGraduations"
}

export const actions = {
    START_REQUEST : "START_TANKS_REQUEST",
    END_REQUEST : "END_TANKS_REQUEST",
    GET_TANKS : "GET_TANKS",
    GET_CURRENT_TANK : "GET_CURRENT_TANK",
    ADD_TANK : "ADD_TANK",
    EDIT_TANK : "EDIT_TANK",
    GET_AREAS : "GET_AREAS",
    ADD_AREA : "ADD_AREA",
    EDIT_AREA : "EDIT_AREA",
    GET_TANKS_OPERATIONS : "GET_TANK_OPERATIONS",
    GET_TANKS_STATE_OPERATIONS: "GET_TANKS_STATE_OPERATIONS",
    SKIP_TANK_LO_LEVEL_NOTIFICATION: "SKIP_TANK_LO_LEVEL_NOTIFICATION"
}